<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="审批意见"
        :label-width="formLabelWidth"
        prop="opinion"
      >
        <el-input
          v-model="editForm.opinion"
          type="textarea"
          :rows="2"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form.js';
import { updateExamineApi } from '@/api/user.js';
export default {
  name: 'editForm',
  data() {
    return {
      appRecordId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      editForm: { ...formData },
      editRules: formRules,
      formLabelWidth: '120px',
    };
  },
  inject: ['reload'],
  computed: {},
  props: [],
  mounted() {},
  methods: {
    resetFrom() {
      this.editForm = {};
    },
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          const data = `appRecordId=${this.appRecordId}&opinion=${this.editForm.opinion}`;
          await updateExamineApi(data).then((res) => {
            if (res.code === 200) {
              this.$message.success('提交成功!');
            }
          });
          this.dialogFormVisible = false;
          this.editForm = {};
          // 重新获取数据
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style></style>
